import { HereLayer } from "common/utils/MapMarker/types";
import { useMemo } from "react";
import { getCarIcon } from "features/cars/CarEBoxLocations/utils";
import { svgToDataURL } from "common/utils";
import { MARKER_HEIGHT, MARKER_WIDTH } from "features/stations";
import {
  NavigationHistoryPath,
  useNavigationHistory,
} from "entities/navigation";
import { useZoomSelector } from "entities/application";

import { EMPTY_ARRAY } from "common/constants";

const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<g filter="url(#filter0_ddd_2269_107120)">
<path d="M8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13Z" fill="#50BC46"/>
<path d="M12.5 8C12.5 10.4853 10.4853 12.5 8 12.5C5.51472 12.5 3.5 10.4853 3.5 8C3.5 5.51472 5.51472 3.5 8 3.5C10.4853 3.5 12.5 5.51472 12.5 8Z" stroke="#339931" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_ddd_2269_107120" x="2" y="2" width="12" height="13" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.16 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2269_107120"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.1 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_2269_107120" result="effect2_dropShadow_2269_107120"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.388235 0 0 0 0 0.447059 0 0 0 0 0.509804 0 0 0 0.12 0"/>
<feBlend mode="normal" in2="effect2_dropShadow_2269_107120" result="effect3_dropShadow_2269_107120"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_2269_107120" result="shape"/>
</filter>
</defs>
</svg>`;

export const useHistoryPathPointMarkerLayer = () => {
  const { path } = useNavigationHistory() || {};
  const currentZoom = useZoomSelector();

  const data = useMemo(
    () => (currentZoom >= 8 ? path || EMPTY_ARRAY : EMPTY_ARRAY),
    [currentZoom, path]
  );

  const clientHistoryEventsMarkersLayer = useMemo(
    (): HereLayer => ({
      data,
      name: "history-path-point",
      type: "marker",
      getCoordinates: (
        { data }: { data: NavigationHistoryPath | { coordinates: { latitude: number; longitude: number; } }}
      ) => {
        if ('locations' in data) {
          const [point] = data.locations;
          const { latitude, longitude } = point;
          return { latitude, longitude };
        }
        
        return {
          latitude: data.coordinates.latitude,
          longitude: data.coordinates.longitude,
        }
      },
      getIcon: ({ clusterWeight, data }) => {
        if (clusterWeight) {
          const { url, width, height } = getCarIcon({
            properties: {
              cluster: true,
              point_count: clusterWeight,
            },
          });

          return {
            url,
            height,
            width,
            anchorY: height,
            anchorX: width / 2
          };
        }

        const { url, height, width } = {
          url: svgToDataURL(svg),
          width: MARKER_WIDTH / 2,
          height: MARKER_HEIGHT / 2,
        };

        return {
          url,
          height,
          width,
          anchorY: height,
          anchorX: width / 2
        };
      }
    }),
    [data]
  );

  return clientHistoryEventsMarkersLayer;
};
